export default __webpack_public_path__ + "static/media/visibility_off.97ee3e4f.svg";